export default typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';



// WEBPACK FOOTER //
// ../../src/utils/isBrowser.js